import config from './config'

function isPercentDisplayed(dataType) {
	return dataType === 'percent' ||
		(dataType === 'score' && config.showScoresAsPercent)
}

export default isPercentDisplayed

isPercentDisplayed.__filename__ = 'components/is-percent-displayed.js'
